<template>
  <sweet-modal ref="success" icon="success" width="500px" @open="countCloseModal('success', 15)">
    {{ $t('ct-saved') }} {{ $t('ct-do-want-publish-website') }}
    <button slot="button" class="btn btn-outline-danger focus" v-on:click="$refs.success.close()">
      {{ $t('ct-not-now') }} {{ this.timeToClose }}
    </button>
    <button slot="button" class="btn btn-outline-success" @click.prevent="publishWebsite()" :disabled="!showRepublish">{{ $t('ct-thats-fine') }}
    </button>
  </sweet-modal>
</template>

<script>
import {SweetModal, SweetModalTab} from "sweet-modal-vue";
import axios from "axios";
import {updateVersion} from "../../js/services/editor/publish";

export default {
  name: "ModalSavedAndPublish",
  components: {
    SweetModal, SweetModalTab
  },
  props: ['id_website', 'showRepublish'],
  data() {
    return {
      timeToClose: 0,
    };
  },
  computed: {
    hasPublishListener() {
      return this.$listeners && this.$listeners.publish
    }
  },
  methods: {
    open() {
      this.$refs.success.open()
    },
    close() {
      this.$refs.success.close()
    },
    countCloseModal: function (ref, seconds) {
      this.timeToClose = seconds;

      let interval = setInterval(() => {
        this.timeToClose--;
      }, 1000);

      setTimeout(() => {
        this.$refs[ref].close();
        clearInterval(interval);
      }, seconds * 1000);
    },

    publishWebsite() {
      if (this.hasPublishListener) {
        this.$emit('publish');
        return;
      }

      if (window.location.hostname === 'localhost') {
        axios.get('http://publication.localhost/cheetah/local-publish-aux').then((res) => {
          console.log(res.data);
        });
      }

      updateVersion(this.id_website)
        .then(() => {
          this.$loading.show();

          setTimeout(() => {
            this.$loading.hide();
            this.$refs.success.close();
          }, 200);
        })
        .catch(error => {
          this.$refs.success.close();

          if (error.response.status === 401) {
            const message = (error.response && error.response.data && error.response.data.message) ? error.response.data.message : 'ct-plan-limited'
            this.$snotify.error(this.$t(message));
          } else {
            this.$snotify.error('Something happened when trying to publish your site, check the settings');
          }
        }); 
    },
  }
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/commons/ModalSavedAndPublish.vue